// extracted by mini-css-extract-plugin
export default {"CheckboxContainer":"J0mDiSEfTq4ARsMdyYYI","CheckboxLabel":"Y8VXiXi9jj6fBxamRKx8"};